<script setup lang="ts">
import { computed, ref, type Ref } from 'vue';
import Select, { type SelectChangeEvent } from 'primevue/select';
import { ZuordnungImportHeader } from '@/models/ZuordnungImportHeader';

const props = withDefaults(
    defineProps<{
        options?: any[];
        headerModel: ZuordnungImportHeader;
    }>(),
    { options: () => [], headerModel: () => new ZuordnungImportHeader() },
);

const headerGroupMap = computed(() => {
    const res = {} as Record<string, Record<string, string>[]>;
    props.options.forEach((option) => {
        res[option.type as string] = option.items.map((o: any) => {
            return { id: o.id, variable: o.variable };
        });
    });
    return res;
});

const emit = defineEmits<{
    (e: 'change', option: SelectChangeEvent): void;
}>();

const modelValue = computed(() => {
    const m =
        headerGroupMap.value[props.headerModel.target_tabelle || '']?.find(
            (h) => h.variable === props.headerModel.header,
        )?.id || '';
    emit('change', { value: m, originalEvent: new Event('select') });
    return m;
});
</script>

<template>
    <Select
        :model-value="modelValue"
        filter
        :options="options"
        optionValue="id"
        optionLabel="bezeichnung_de"
        optionGroupLabel="type"
        optionGroupChildren="items"
        :placeholder="$t('bitte_waehlen')"
        class="w-full"
        @change="(value) => $emit('change', value)"
    >
        <template #optiongroup="slotProps">
            <div class="flex align-items-center">
                <i class="fa-regular fa-file"></i>
                <div class="ml-0_5rem">
                    {{ $t(slotProps.option.type) }}
                </div>
            </div>
        </template>
    </Select>
</template>
